import { DateTime } from 'luxon';
import { onlineStatus } from '../checks/onlineStatus.js';
import type { RolesWithPermissions } from '../permissions.js';

export const actor: RolesWithPermissions['actor'] = {
  permissions: {
    OSCEs: { viewnew: false, viewratedonce: false, create: false, modify: false, delete: false },
    instructionCategories: { view: false },
    answers: {
      createempty: false,
      modifyaudio: false,
      modifytranscript: false,
      create: false,
      modify: false,
      delete: false,
    },
    examdays: {
      create: false,
      modify: false,
      modifymissingcandidates: false,
      schedule: false,
      printcandiates: false,
      sendinfomail: false,
      viewselect: true,
      operate: false,
      viewstatistics: false,
      delete: false,
    },
    finalratings: { view: false, create: false, modify: false, delete: false },
    invoices: { create: false, view: false },
    mails: { modify: false, view: false, create: false, delete: false },
    orders: {
      createmanual: false,
      modifycomment: false,
      move: false,
      revoke: false,
      setpaid: false,
      view: false,
      modify: false,
      create: false,
    },
    results: { sendmail: false, view: false },
    certificates: { sendmail: false, view: false },
    ratings: {
      modifyownnotes: false,
      view: false,
      viewoverview: false,
      viewothers: false,
      create: false,
      modify: false,
      delete: false,
    },
    shortTokens: { view: false, create: false, modify: false, delete: false },
    slots: {
      createfallback: false,
      extend: false,
      rate: false,
      view: false,
      viewothers: false,
      delete: false,
      spectate: false,
      modifycomment: false,
      usefallbackactor: false,
      create: false,
      modify: false,
    },
    timeline: {
      view: (user, day) =>
        !!day?.osceTesterTuples.find(t => t.testerIDs?.includes(user._id)) || !!day?.fallbackTesters.includes(user._id),
      viewadmin: false,
    },
    users: {
      create: false,
      modify: (user, userData) => {
        if (!userData) return false;
        return userData._id === user._id;
      },
      modifyassignedosces: false,
      view: false,
      delete: false,
      impersonate: false,
    },
    reportedErrors: { create: false, view: false, resolve: false },
    termins: { create: false, view: false, schedule: false },
    timeslots: { view: false, create: false, delete: false },
    osceGroups: { create: false, modify: false, delete: false },
    scores: { create: false, modify: false, delete: false },
    eventLogs: { create: true, modify: false, delete: false },
    files: { create: true, modify: true, delete: false },
    onlineStatus,
    counters: { create: true, modify: true, delete: true },
    dataViewConfigs: { create: true, modify: true, delete: true },
    examDayReservations: { create: true, modify: true, delete: true },
    locations: { create: false, modify: false, delete: false, view: false },
  },
  allowedPages: {
    start: 1,
    scheduling: 1,
    'check-in': 1,
    'content-osce': 1,
    exam: 1,
    soundcheck: 1,
  },
  examDayFilter: user => {
    return {
      archived: { $ne: true },
      $and: [
        { $or: [{ published: true }, { isPublishedForTesters: true }] },
        { $or: [{ 'osceTesterTuples.testerIDs': user._id }, { fallbackTesters: user._id }] },
      ],
      end: { $gte: DateTime.now().minus({ weeks: 2 }).toJSDate() },
    };
  },
};
